import type { EnglishIqDailyTargetMinutesType } from '@repo/config';
import type { AssessmentSkillType } from '../types';

export interface IAssessmentRoutineDay {
  check: boolean;
  day: number;
  lessonCount: number;
  repetitionCount: number;
  skillFocus: AssessmentSkillType | null;
}

interface IBuildAssessmentSevenDayRoutineParams {
  dailyTargetMinutes: EnglishIqDailyTargetMinutesType;
  subBand: string;
}

function resolveLevelProfile(subBand: string): {
  lessonAdjustment: number;
  repetitionAdjustment: number;
  skillFocus: readonly [AssessmentSkillType, AssessmentSkillType];
} {
  if (subBand.startsWith('A')) {
    return { lessonAdjustment: -1, repetitionAdjustment: 2, skillFocus: ['grammar', 'meaning'] };
  }
  if (subBand.startsWith('C')) {
    return { lessonAdjustment: 1, repetitionAdjustment: -1, skillFocus: ['meaning', 'listening'] };
  }
  return { lessonAdjustment: 0, repetitionAdjustment: 0, skillFocus: ['grammar', 'listening'] };
}

export function buildAssessmentSevenDayRoutine({
  dailyTargetMinutes,
  subBand,
}: IBuildAssessmentSevenDayRoutineParams): IAssessmentRoutineDay[] {
  const scale = dailyTargetMinutes / 5;
  const profile = resolveLevelProfile(subBand);
  return Array.from({ length: 7 }, (_, index) => ({
    check: index === 6,
    day: index + 1,
    lessonCount: Math.max(1, Math.round(scale) + profile.lessonAdjustment),
    repetitionCount: Math.max(2, Math.round(scale * 2 + index / 2) + profile.repetitionAdjustment),
    skillFocus: index === 2 ? profile.skillFocus[0] : index === 5 ? profile.skillFocus[1] : null,
  }));
}
